(function() {
  'use strict';

  angular
    .module('pub.products', [])
    .controller('ProductsCtrl', ProductsCtrl);

  /** @ngInject */
  function ProductsCtrl($scope, $controller, $rootScope) {
    var vm = this;
    vm.items = [];

    $rootScope.page = 'Products';
    $controller('ListCtrl', {$scope: vm});

    vm.parentType = null;
    vm.itemType = 'products';
    vm.childType = null;

    vm.editGrid = false;
    vm.editing = false;

    vm.load();

  }

})();
